module.exports = __webpack_public_path__ + "static/media/badge_footer_preview.11384433.svg";